module.exports = __webpack_public_path__ + "img/lg_ring_r_s_null_null@3x.13bbc4de.png";